import { BaseComponent } from "./BaseComponent";

export abstract class BaseCreateComponent<
  TElement extends HTMLElement,
> extends BaseComponent<TElement> {
  protected abstract getTagName(): string;

  protected abstract getElementId(): string;

  protected getCssClassList(): string[] | null {
    return null;
  }

  protected afterInit(_element: TElement): void {}

  protected beforeDispose(_element: TElement): void {}

  protected getElement(): TElement {
    return this._element;
  }

  //

  public init(): void {
    this._initElement();
    document.body.appendChild(this._element);
    this.afterInit(this._element);
  }

  public dispose(): void {
    this.beforeDispose(this._element);
    if (document.body.contains(this._element)) {
      document.body.removeChild(this._element);
    }
  }

  //

  private _element!: TElement;

  private _initElement(): void {
    this._element = this.createElement(
      this.getTagName(),
      this.getElementId(),
      this.getCssClassList(),
    );
  }
}
